(() => {

 let lastTrigger;

 const desktop = matchMedia('(min-width:769px)');

 desktop.addEventListener('change',()=>document.querySelectorAll('[data-mc-responsive-details]').forEach(details=>details.open=desktop.matches));

 function prepare(scope=document){

  scope.querySelectorAll('.mc-product-description').forEach(desc=>{

   desc.querySelectorAll('table,[role="table"]').forEach(table=>{if(!table.parentElement.classList.contains('mc-table-scroll')){const wrap=document.createElement('div');wrap.className='mc-table-scroll';table.before(wrap);wrap.append(table);}});

   const id=desc.dataset.mcProductDescription,benefits=document.querySelector('[data-mc-product-benefits="'+id+'"]');

   if(benefits&&benefits.hidden){Array.from(desc.querySelectorAll('ul li')).slice(0,3).forEach(item=>{const li=document.createElement('li'),icon=document.createElement('span');icon.textContent='✓';icon.setAttribute('aria-hidden','true');li.append(icon,document.createTextNode(item.textContent.trim()));benefits.append(li)});benefits.hidden=!benefits.children.length;}

   const dialog=document.getElementById('mc-size-guide-'+id),content=dialog?.querySelector('[data-mc-size-guide-content]');
   if(dialog&&content&&!dialog.hasAttribute('data-mc-auto-size-guide-dialog')){
    const tables=Array.from(desc.querySelectorAll('table,[role="table"]'));
    const headings=Array.from(desc.querySelectorAll('h1,h2,h3,h4,strong'));
    let chartTable=tables.find(function(table){
     const previousHeading=headings.filter(function(heading){return (heading.compareDocumentPosition(table)&Node.DOCUMENT_POSITION_FOLLOWING)!==0;}).pop();
     if(previousHeading&&/size|sizing|measurement/i.test(previousHeading.textContent.trim()))return true;
     const text=table.textContent.toLowerCase();
     return /\b(size|bust|waist|chest|shoulder|hip|inseam|foot length|length)\b/i.test(text)&&/\b(cm|in|inch|bust|waist|chest|shoulder|hip|foot|length)\b/i.test(text);
    });
    if(!chartTable&&tables.length===1)chartTable=tables[0];
    const metafieldTable=desc.closest('.product-single__meta,section')?.querySelector('.mc-inline-size-table table');
    const sourceTable=chartTable||metafieldTable;
    if(sourceTable){
     const wrapper=document.createElement('div');
     wrapper.className='mc-table-scroll';
     wrapper.append(sourceTable.cloneNode(true));
     content.replaceChildren(wrapper);
    }
   }

   if(dialog?.hasAttribute('data-mc-clean-size')&&content?.querySelector('table')&&!content.dataset.cleanSizeReady){
    const source=content.querySelector('table'),rows=[...source.querySelectorAll('tbody tr')],table=document.createElement('table'),head=document.createElement('thead'),body=document.createElement('tbody');
    const titles=['Size','Jacket bust (in)','Length (in)'],tr=document.createElement('tr');titles.forEach(label=>{const th=document.createElement('th');th.scope='col';th.textContent=label;tr.append(th)});head.append(tr);
    rows.forEach(row=>{const cells=[...row.querySelectorAll('td')];if(cells.length<5)return;const line=document.createElement('tr');[cells[0].textContent.trim(),cells[3].textContent.split('/').pop().trim().replace(/\s*in$/,''),cells[4].textContent.split('/').pop().trim().replace(/\s*in$/,'')].forEach(text=>{const td=document.createElement('td');td.textContent=text;line.append(td)});body.append(line)});
    if(body.children.length){table.append(head,body);content.replaceChildren(table);content.dataset.cleanSizeReady='true';}
   }

   desc.querySelectorAll('p').forEach(p=>{
    if(!p.querySelector('br'))return;
    const rows=p.innerHTML.split(/<br\s*\/?\s*>/i).map(html=>{const span=document.createElement('span');span.innerHTML=html;return span.textContent.trim();}).filter(Boolean);
    if(rows.length<3||!rows.every(row=>row.includes(':')))return;
    const dl=document.createElement('dl');dl.className='mc-pdp-specifications';
    rows.forEach(row=>{const split=row.indexOf(':'),group=document.createElement('div'),dt=document.createElement('dt'),dd=document.createElement('dd');dt.textContent=row.slice(0,split).trim();dd.textContent=row.slice(split+1).trim();group.append(dt,dd);dl.append(group);});p.replaceWith(dl);
   });
   const heading=Array.from(desc.querySelectorAll('h2,h3,h4')).find(el=>/^product details$/i.test(el.textContent.trim()));
   const tab=desc.closest('.product-single__meta')?.querySelector('[data-mc-specifications-tab]'),specs=tab?.querySelector('[data-mc-specifications-content]');
   if(heading&&specs){let node=heading.nextElementSibling;while(node&&!/^H[234]$/.test(node.tagName)){const next=node.nextElementSibling;specs.append(node);node=next;}if(specs.children.length){heading.remove();tab.hidden=false;}}
   const details=desc.closest('[data-mc-responsive-details]');if(details&&!details.dataset.ready){details.open=desktop.matches;details.dataset.ready='true';const first=desc.querySelector('p');if(first){const intro=document.createElement('p');intro.className='mc-product-intro';intro.textContent=first.textContent.trim().split(/(?<=[.!?])\s+/).slice(0,2).join(' ');details.before(intro);}}



  });

 }

 document.addEventListener('click',event=>{

  const opener=event.target.closest('[data-mc-size-guide-open]');if(opener){const dialog=document.getElementById(opener.getAttribute('aria-controls'));if(dialog){lastTrigger=opener;dialog.showModal();}}

  const closer=event.target.closest('[data-mc-size-guide-close]');if(closer)closer.closest('dialog').close();

  if(event.target.matches('dialog[data-mc-size-guide-dialog]')){const r=event.target.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)event.target.close();}

 });

 document.addEventListener('close',event=>{if(event.target.matches('[data-mc-size-guide-dialog]'))lastTrigger?.focus()},true);

 document.addEventListener('shopify:section:load',()=>prepare());

 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>prepare());else prepare();

})();

